import React from "react";
import "./CardTextSection.css";
import ChartGridSection from "./ChartGridSection";

export default function CardTextSection({
  heading,
  description,
  chartData,
  chartFooter,
}) {
  return (
    <section className="container card-text-section">
      <div>
        <h2>{heading}</h2>
        <p>{description}</p>
      </div>

      <div className="cts-chart-block ">
        <ChartGridSection chartData={chartData} chartFooter={chartFooter} />
      </div>
    </section>
  );
}
